import { usePaywallCheckoutContext } from "@circle-react/contexts/Paywalls/paywallCheckoutContext";
import { classNames } from "@circle-react/helpers/twMergeWithCN";
import { CheckoutVerificationHandler } from "../CheckoutVerificationHandler";
import { StripeElementsManager } from "../StripeElementsManager";
import { CheckoutDescription } from "./CheckoutDescription";
import { CheckoutForm } from "./CheckoutForm";
import { PricePreview } from "./CheckoutForm/PricePreview";
import { SSOLoginPrompt } from "./SSOLoginPrompt";
import { Container } from "./components/Container";
import { GridColumns } from "./components/GridColumns";

export const CheckoutPage = () => {
  const { authProviderProperties } = usePaywallCheckoutContext();

  return (
    <Container>
      {!authProviderProperties?.is_sso_authentication_required && (
        <PricePreview variant="mobile_fixed_on_top" />
      )}
      <GridColumns
        className={classNames(
          "bg-primary h-full gap-y-6 *:px-5 md:gap-y-10 md:pt-0",
          {
            "pt-12 *:lg:pt-0":
              !authProviderProperties?.is_sso_authentication_required,
          },
        )}
        dataTestId="paywall-checkout-container"
      >
        <CheckoutDescription className="!bg-secondary pb-8 md:pb-10 xl:pr-28" />
        <SSOLoginPrompt className="xl:pl-28" />
        <StripeElementsManager>
          <CheckoutForm className="bg-primary pb-8 xl:pl-28" />
        </StripeElementsManager>
      </GridColumns>
      <CheckoutVerificationHandler />
    </Container>
  );
};
